const PreSearchCriteria = {
    isPriorName: false,
    isSearchTargetMarket: false,
    searchType: 'sales'
}

export default PreSearchCriteria
